// extracted by mini-css-extract-plugin
export default {"shell":"miniapp-shell_shell__iuivr"};